<div class="row m-0 py-3 status-count-container">
    <div class="col" *ngFor="let st of data;index as i">
        <div class="status-count" (click)="onStatusClick(st, i)" [ngClass]="{ 'status-selected': st.selected}">
            <h1>{{st.count}}</h1>
            <h6>{{st.status}}</h6>
        </div>
    </div>
</div>